export default "__VITE_ASSET__BTdU9g$V__"